// extracted by mini-css-extract-plugin
module.exports = {"lineChartWrap":"LineChart_lineChartWrap__2fjHl","downloadButton":"LineChart_downloadButton__3l7LA","iconDownload":"LineChart_iconDownload__3f-OS"};